import { createTheme } from '@mantine/core';

const theme = createTheme({
  /* ── Colors ── */
  colors: {
    brand: [
      '#eff6ff',  // 0
      '#dbeafe',  // 1
      '#bfdbfe',  // 2
      '#93c5fd',  // 3
      '#60a5fa',  // 4
      '#1D4ED8',  // 5 - main brand (cobalt)
      '#1e40af',  // 6 - hover
      '#1e3a8a',  // 7
      '#172554',  // 8
      '#0f172a',  // 9
    ],
  },
  primaryColor: 'brand',
  primaryShade: 5,
  focusRing: 'auto',
  cursorType: 'pointer',

  /* ── Typography ── */
  fontFamily: "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  headings: {
    fontFamily: "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontWeight: '600',
  },
  fontSizes: {
    xs: '12px',
    sm: '13.5px',
    md: '15px',
    lg: '17px',
    xl: '20px',
  },

  /* ── Spacing ── */
  spacing: {
    xs: '6px',
    sm: '10px',
    md: '16px',
    lg: '22px',
    xl: '32px',
  },

  /* ── Radius ── */
  radius: {
    xs: '4px',
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
  },
  defaultRadius: 'md',

  /* ── Component defaults ── */
  components: {
    Button: {
      defaultProps: {
        size: 'sm',
        radius: 'md',
      },
      styles: {
        root: { fontWeight: 600 },
      },
    },
    TextInput: {
      defaultProps: {
        size: 'sm',
      },
    },
    Select: {
      defaultProps: {
        size: 'sm',
      },
    },
    PasswordInput: {
      defaultProps: {
        size: 'sm',
      },
    },
    Modal: {
      defaultProps: {
        centered: true,
        overlayProps: { backgroundOpacity: 0.3, blur: 6 },
        radius: 'lg',
      },
    },
    Notification: {
      defaultProps: {
        radius: 'md',
      },
    },
    Card: {
      defaultProps: {
        radius: 'lg',
        padding: 'lg',
        withBorder: true,
      },
    },
    Paper: {
      defaultProps: {
        radius: 'lg',
      },
    },
    Badge: {
      defaultProps: {
        size: 'sm',
        variant: 'light',
        radius: 'sm',
      },
    },
    Table: {
      defaultProps: {
        verticalSpacing: 'md',
        horizontalSpacing: 'lg',
        highlightOnHover: true,
      },
      styles: {
        th: {
          fontSize: '12px',
          fontWeight: 500,
          color: 'var(--mantine-color-gray-5)',
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
          borderBottom: '1px solid var(--mantine-color-gray-2)',
        },
        td: {
          borderBottom: '1px solid var(--mantine-color-gray-1)',
        },
      },
    },
    Title: {
      styles: {
        root: { letterSpacing: '-0.02em' },
      },
    },
  },
});

export default theme;
